import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from '../../../adapter-vue';
import { isUniFrameWork } from '../../../utils/env';

interface IProps {
  url: string;
  size?: string;
  borderRadius?: string;
  useSkeletonAnimation?: boolean;
}

interface IEmits {
  (key: 'onLoad', e: Event): void;
  (key: 'onError', e: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    url: { default: "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png" },
    size: { default: "36px" },
    borderRadius: { default: "5px" },
    useSkeletonAnimation: { type: Boolean, default: false }
  },
  emits: ["onLoad", "onError"],
  setup(__props: any, { emit: emits }: { emit: ({
  (key: 'onLoad', e: Event): void;
  (key: 'onError', e: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { url: string, size: string, borderRadius: string, useSkeletonAnimation: boolean }

const defaultAvatarUrl = "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png";



const {
  size: avatarSize,
  url: avatarImageUrl,
  borderRadius: avatarBorderRadius,
  useSkeletonAnimation: useAvatarSkeletonAnimation,
} = toRefs(props);

const isImgLoaded = ref<boolean>(false);
const loadErrorInUniapp = ref<boolean>(false);

function avatarLoadSuccess(e: Event) {
  isImgLoaded.value = true;
  emits('onLoad', e);
}

function avatarLoadFailed(e: Event) {
  if (isUniFrameWork) {
    loadErrorInUniapp.value = true;
  } else {
    (e.currentTarget as HTMLImageElement).src = defaultAvatarUrl;
  }
  emits('onError', e);
}

return { __sfc: true,defaultAvatarUrl, emits, props, avatarSize, avatarImageUrl, avatarBorderRadius, useAvatarSkeletonAnimation, isImgLoaded, loadErrorInUniapp, avatarLoadSuccess, avatarLoadFailed, isUniFrameWork }
}

})